<groundworks-card [cardClasses]="['shadow-none']">
  <groundworks-card-body>
    <h2 class="h5 mb-4">Financing</h2>
    <div class="row justify-content-between">
      <div class="col-md-2">
        <strong>Finance Company: </strong>
        <span id="finance-company-value">{{ financing.financingCompanyName }}</span>
      </div>
      <div class="col-md-2">
        <strong>Finance Plan: </strong>
        <span id="finance-plan-value">{{ financing.financingPlan }}</span>
      </div>
      <div class="col-md-2">
        <strong>Total Job Amount: </strong>
        <span id="total-job-amount-value">{{
            soldTotal | currency : 'USD' : 'symbol' : '1.2-2'
          }}</span>
      </div>
      <div class="col-md-2">
        <strong>Amount Financed: </strong>
        <span id="amount-financed-value">{{
          financing.financingPaymentAmount | currency : 'USD' : 'symbol' : '1.2-2'
        }}</span>
      </div>
      <div class="col-md-2">
        <strong>Created: </strong>
        <span id="created-value">{{ financing.createdAt | date : 'MM/dd/yyyy hh:mm a' }}</span>
      </div>
    </div>
  </groundworks-card-body>
</groundworks-card>
